/* Table Box Atelier — theme.js (vanilla, no dependencies) */
(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const T = window.theme || { routes: {}, strings: {} };
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isDesktop = () => matchMedia('(min-width: 990px)').matches;
  const fmt = (cents) => 'AED ' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    const el = $('[data-toast]'); if (!el) return;
    el.textContent = msg; el.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(() => { el.hidden = true; }, 3200);
  }

  /* ---------- Drawers ---------- */
  let lastFocus = null;
  function openDrawer(id) {
    const d = document.getElementById(id); if (!d) return;
    $$('.drawer.is-open').forEach((o) => o !== d && closeDrawer(o, false));
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    if (!reduceMotion) { d.classList.add('is-entering'); clearTimeout(d._ent); d._ent = setTimeout(() => d.classList.remove('is-entering'), 1600); }
    document.documentElement.classList.add('lock');
    const f = $('[data-autofocus]', d) || $('.drawer__panel button, .drawer__panel a, .drawer__panel input', d);
    if (f) setTimeout(() => f.focus({ preventScroll: true }), 80);
  }
  function closeDrawer(d, restore = true) {
    if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.documentElement.classList.remove('lock');
    if (restore && lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-drawer-open]');
    if (o) { e.preventDefault(); openDrawer(o.dataset.drawerOpen); return; }
    const c = e.target.closest('[data-drawer-close]');
    if (c) { e.preventDefault(); closeDrawer(c.closest('.drawer')); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const d = $('.drawer.is-open'); if (d) closeDrawer(d);
    $$('[data-quick-panel]:not([hidden])').forEach(closeQuick);
    const pop = $('[data-look-pop]:not([hidden])'); if (pop) pop.hidden = true;
  });
  // Focus trap for open drawer
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;
    const d = $('.drawer.is-open'); if (!d || (d.classList.contains('facets') && isDesktop())) return;
    const f = $$('a[href], button:not([disabled]), input:not([disabled]):not([type=hidden]), select, textarea', $('.drawer__panel', d)).filter((x) => x.offsetParent !== null);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- Header ---------- */
  function initHeader() {
    const h = $('[data-header]'); if (!h) return;
    const setH = () => document.documentElement.style.setProperty('--header-h', (h.classList.contains('is-sticky') ? h.offsetHeight : 0) + 'px');
    setH();
    if ('ResizeObserver' in window) new ResizeObserver(setH).observe(h);
    const onScroll = () => h.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
    $$('.nav__item.has-mega', h).forEach((li) => {
      const a = $('.nav__link', li);
      li.addEventListener('mouseenter', () => a.setAttribute('aria-expanded', 'true'));
      li.addEventListener('mouseleave', () => { a.setAttribute('aria-expanded', 'false'); li.classList.remove('is-open'); });
      li.addEventListener('focusout', (e) => { if (!li.contains(e.relatedTarget)) { a.setAttribute('aria-expanded', 'false'); li.classList.remove('is-open'); } });
      a.addEventListener('keydown', (e) => { if (e.key === 'ArrowDown') { e.preventDefault(); li.classList.add('is-open'); a.setAttribute('aria-expanded', 'true'); const f = $('.mega a', li); f && f.focus(); } });
    });
  }

  /* ---------- Announcement / rotate ---------- */
  function initRotate(root = document) {
    $$('[data-rotate]', root).forEach((wrap) => {
      const items = $$('[data-rotate-item]', wrap); if (items.length < 2 || wrap._rot) return;
      let i = 0; wrap._rot = setInterval(() => {
        items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active');
      }, 4500);
    });
  }

  /* ---------- Cart ---------- */
  const Cart = {
    sectionIds() {
      const ids = ['cart-drawer'];
      const main = $('[data-main-cart]'); if (main) ids.push(main.dataset.sectionId);
      return ids;
    },
    async post(url, body) {
      const r = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      const j = await r.json().catch(() => ({}));
      if (!r.ok || j.status) throw new Error(j.description || j.message || T.strings.error);
      return j;
    },
    render(sections) {
      if (!sections) return;
      const dHtml = sections['cart-drawer'];
      if (dHtml) {
        const doc = parse(dHtml);
        const cnt = $('[data-cart-count-source]', doc);
        const n = cnt ? parseInt(cnt.textContent, 10) || 0 : null;
        const next = $('[data-cart-drawer-inner]', doc), cur = $('[data-cart-drawer-inner]');
        if (next && cur) cur.replaceWith(next);
        if (n !== null) this.count(n);
      }
      const main = $('[data-main-cart]');
      if (main && sections[main.dataset.sectionId]) {
        const doc = parse(sections[main.dataset.sectionId]);
        const next = $('[data-main-cart-inner]', doc), cur = $('[data-main-cart-inner]', main);
        if (next && cur) cur.replaceWith(next);
      }
    },
    count(n) {
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = n; el.classList.toggle('is-empty', n === 0);
        el.classList.add('is-bump'); setTimeout(() => el.classList.remove('is-bump'), 400);
      });
    },
    async add(items, { open = true } = {}) {
      const j = await this.post(T.routes.cartAdd + '.js', { items, sections: this.sectionIds(), sections_url: location.pathname });
      this.render(j.sections);
      const added = (j.items || []).filter((it) => it.id !== T.giftWrapVariantId);
      added.forEach((it) => $$(`[data-line-key="${it.key}"]`).forEach((el) => el.classList.add('is-new')));
      if (open && added.length) this.notice(added);
      const drawer = document.getElementById('cart-drawer');
      if (open && !$('[data-main-cart]')) { if (drawer && drawer.classList.contains('is-open')) { drawer.classList.add('is-entering'); clearTimeout(drawer._ent); drawer._ent = setTimeout(() => drawer.classList.remove('is-entering'), 1600); } else openDrawer('cart-drawer'); }
      else toast(T.strings.added);
      document.dispatchEvent(new CustomEvent('cart:updated'));
      return j;
    },
    async change(payload) {
      const wrap = $('[data-cart-drawer-inner]'); wrap && wrap.classList.add('is-loading');
      try {
        const j = await this.post(T.routes.cartChange + '.js', Object.assign(payload, { sections: this.sectionIds(), sections_url: location.pathname }));
        this.render(j.sections); this.count(j.item_count);
      } finally { const w = $('[data-cart-drawer-inner]'); w && w.classList.remove('is-loading'); }
    },
    notice(added) {
      const body = $('[data-cart-drawer-inner] .drawer__body'); if (!body) return;
      const name = added.length > 1 ? added.length + ' pieces' : (added[0].product_title || added[0].title || '');
      const n = document.createElement('div');
      n.className = 'cart-added'; n.setAttribute('role', 'status');
      n.innerHTML = '<svg class="cart-added__check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="m7.5 12.5 3 3 6-6.5"/></svg><span>' + T.strings.added + '</span><span class="cart-added__name"></span>';
      n.querySelector('.cart-added__name').textContent = name;
      body.prepend(n);
      setTimeout(() => { n.classList.add('is-leaving'); setTimeout(() => n.remove(), 600); }, 4200);
    },
    attrs(attributes) { return this.post(T.routes.cartUpdate + '.js', { attributes }); }
  };
  window.TableBoxCart = Cart;

  function busy(btn, on) { if (btn) { btn.classList.toggle('is-busy', on); btn.setAttribute('aria-busy', on ? 'true' : 'false'); } }

  document.addEventListener('click', async (e) => {
    // Cart quantity / remove
    const q = e.target.closest('[data-cart-qty]');
    if (q) {
      e.preventDefault();
      try { await Cart.change({ line: parseInt(q.dataset.line, 10), quantity: Math.max(0, parseInt(q.dataset.qty, 10)) }); }
      catch (err) { toast(err.message); }
      return;
    }
    // Quick add (cards, shop-the-look items, quick panels)
    const qa = e.target.closest('[data-quick-add]');
    if (qa) {
      e.preventDefault();
      const id = parseInt(qa.dataset.variantId, 10); if (!id) return;
      busy(qa, true);
      try { await Cart.add([{ id, quantity: 1 }]); const p = qa.closest('[data-quick-panel]'); p && closeQuick(p); }
      catch (err) { toast(err.message); }
      finally { busy(qa, false); }
      return;
    }
    // Quick panel toggle
    const qo = e.target.closest('[data-quick-open]');
    if (qo) {
      e.preventDefault();
      const panel = $('[data-quick-panel]', qo.closest('[data-quick]'));
      const willOpen = panel.hidden;
      $$('[data-quick-panel]:not([hidden])').forEach(closeQuick);
      if (willOpen) { panel.hidden = false; qo.setAttribute('aria-expanded', 'true'); const f = $('button:not([disabled])', panel); f && f.focus(); }
      return;
    }
    if (!e.target.closest('[data-quick]')) $$('[data-quick-panel]:not([hidden])').forEach(closeQuick);
    // Add set (complete the look)
    const set = e.target.closest('[data-add-set]');
    if (set) {
      e.preventDefault();
      const items = set.dataset.addSet.split(',').filter(Boolean).map((id) => ({ id: parseInt(id, 10), quantity: 1 }));
      busy(set, true);
      try { await Cart.add(items); } catch (err) { toast(err.message); } finally { busy(set, false); }
    }
  });
  function closeQuick(p) { p.hidden = true; const b = $('[data-quick-open]', p.closest('[data-quick]')); b && b.setAttribute('aria-expanded', 'false'); }

  // Gift wrap toggle + gift attributes in cart
  document.addEventListener('change', async (e) => {
    const t = e.target;
    if (t.matches('[data-gift-wrap-toggle]')) {
      if (!T.giftWrapVariantId) return;
      try {
        if (t.checked) await Cart.add([{ id: T.giftWrapVariantId, quantity: 1 }], { open: false });
        else await Cart.change({ id: String(T.giftWrapVariantId), quantity: 0 });
      } catch (err) { toast(err.message); t.checked = !t.checked; }
    }
    if (t.matches('input[type=checkbox][data-cart-attr]')) {
      Cart.attrs({ [t.dataset.cartAttr]: t.checked ? 'Yes' : '' }).catch(() => {});
    }
  });
  const pendingAttrs = {};
  const flushAttrs = debounce(() => { const a = Object.assign({}, pendingAttrs); Object.keys(pendingAttrs).forEach((k) => delete pendingAttrs[k]); Cart.attrs(a).catch(() => {}); }, 500);
  document.addEventListener('input', (e) => {
    const t = e.target;
    if (t.matches('textarea[data-cart-attr], input[type=text][data-cart-attr]')) { pendingAttrs[t.dataset.cartAttr] = t.value; flushAttrs(); }
  });

  /* ---------- Product form ---------- */
  document.addEventListener('submit', async (e) => {
    const f = e.target.closest('form.pdp__form'); if (!f) return;
    e.preventDefault();
    const btn = $('[type=submit]', f);
    const fd = new FormData(f);
    const id = parseInt(fd.get('id'), 10);
    const quantity = Math.max(1, parseInt(fd.get('quantity') || '1', 10));
    const properties = {};
    for (const [k, v] of fd.entries()) { const m = k.match(/^properties\[(.+)\]$/); if (m && String(v).trim()) properties[m[1]] = v; }
    const items = [{ id, quantity, properties }];
    if (fd.get('gift_wrap') && T.giftWrapVariantId) items.push({ id: T.giftWrapVariantId, quantity: 1 });
    const stickyBtn = $('[data-sticky-btn]');
    busy(btn, true); busy(stickyBtn, true);
    try { await Cart.add(items); } catch (err) { toast(err.message); }
    finally { busy(btn, false); busy(stickyBtn, false); }
  });

  // Quantity steppers on product page
  document.addEventListener('click', (e) => {
    const s = e.target.closest('[data-qty-step]'); if (!s) return;
    const input = $('input', s.closest('.qty'));
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(s.dataset.qtyStep, 10));
  });

  // Gift toggle on product page
  document.addEventListener('change', (e) => {
    const t = e.target; if (!t.matches('[data-gift-toggle]')) return;
    const body = $('[data-gift-body]', t.closest('.gift-opt'));
    body.hidden = !t.checked;
    $$('[data-gift-field]', body).forEach((x) => { x.disabled = !t.checked; });
  });

  /* ---------- Variant picker ---------- */
  function initVariantPicker(root = document) {
    $$('[data-variant-picker]', root).forEach((vp) => {
      if (vp._init) return; vp._init = true;
      const json = $('[data-variants-json]', vp); if (!json) return;
      const variants = JSON.parse(json.textContent);
      const form = document.getElementById(vp.dataset.form);
      const section = vp.closest('[data-pdp]');
      const update = () => {
        const fieldsets = $$('[data-option]', vp);
        const sel = fieldsets.map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });
        const v = variants.find((x) => x.options.every((o, i) => o === sel[i]));
        fieldsets.forEach((fs, i) => {
          const lbl = $('[data-option-value]', fs); if (lbl) lbl.textContent = sel[i] || '';
          $$('input', fs).forEach((inp) => {
            const test = sel.slice(); test[i] = inp.value;
            const m = variants.find((x) => x.options.every((o, j) => o === test[j]));
            inp.closest('.opt__item').classList.toggle('is-unavailable', !m || !m.available);
          });
        });
        const btn = $('[type=submit]', form), label = $('[data-atc-label]', form);
        const sticky = $('[data-sticky-btn]'), avail = $('[data-availability]', section);
        if (!v) { btn.disabled = true; label.textContent = T.strings.unavailable; if (sticky) sticky.disabled = true; return; }
        $('[name=id]', form).value = v.id;
        btn.disabled = !v.available; label.textContent = v.available ? T.strings.addToBox : T.strings.soldOut;
        if (sticky) { sticky.disabled = !v.available; sticky.textContent = v.available ? T.strings.addToBox : T.strings.soldOut; }
        const priceHtml = `<span class="price${v.compare_at_price > v.price ? ' price--sale' : ''}"><span class="price__now">${fmt(v.price)}</span>${v.compare_at_price > v.price ? `<s class="price__compare">${fmt(v.compare_at_price)}</s>` : ''}</span>`;
        $$('[data-price-wrap]', section).forEach((p) => { p.innerHTML = priceHtml; });
        const sp = $('[data-sticky-price]'); if (sp) sp.textContent = fmt(v.price);
        if (avail) { avail.textContent = v.available ? T.strings.inStock : T.strings.soldOut; avail.classList.toggle('is-out', !v.available); }
        const notify = $('[data-notify]', section); if (notify) notify.hidden = !!v.available;
        const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
        if (v.featured_media) {
          const gallery = $('[data-gallery]', section);
          const item = gallery && $(`[data-media-id="${v.featured_media.id}"]`, gallery);
          if (item && gallery.firstElementChild !== item) { gallery.prepend(item); }
          if (gallery) gallery.scrollTo({ left: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      };
      vp.addEventListener('change', (e) => { if (e.target.matches('[data-option-input]')) update(); });
    });
  }

  /* ---------- Gallery (mobile counter, zoom) ---------- */
  function initGallery(root = document) {
    $$('[data-gallery]', root).forEach((g) => {
      if (g._init) return; g._init = true;
      const counter = $('[data-gallery-current]', g.parentElement);
      const bar = $('[data-gallery-bar]', g.parentElement);
      if (bar) g.addEventListener('scroll', () => {
        const max = g.scrollWidth - g.clientWidth; const n = $$('.gallery__item', g).length;
        if (max > 0) bar.style.transform = `translateX(${(g.scrollLeft / max) * (n - 1) * 100}%)`;
      }, { passive: true });
      if (counter && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver((ents) => ents.forEach((en) => {
          if (en.isIntersecting && en.intersectionRatio > .6) counter.textContent = $$('.gallery__item', g).indexOf(en.target) + 1;
        }), { root: g, threshold: [.6] });
        $$('.gallery__item', g).forEach((i) => io.observe(i));
      }
    });
  }
  document.addEventListener('click', (e) => {
    const z = e.target.closest('[data-zoom]');
    if (z) {
      const dlg = $('[data-zoom-dialog]'); if (!dlg || !dlg.showModal) return;
      $('img', dlg).src = z.dataset.zoom; dlg.showModal(); return;
    }
    const zc = e.target.closest('[data-zoom-dialog]');
    if (zc && (e.target.matches('img') || e.target.closest('[data-zoom-close]') || e.target === zc)) zc.close();
  });

  /* ---------- Sticky add-to-cart (mobile) ---------- */
  function initSticky() {
    const bar = $('[data-sticky-atc]'), main = $('[data-atc]');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(([en]) => {
      const show = !en.isIntersecting && en.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show); bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('has-sticky', show && !isDesktop());
    }).observe(main);
  }

  /* ---------- Hero slideshow ---------- */
  function initHero(root = document) {
    $$('[data-hero]', root).forEach((hero) => {
      const slides = $$('[data-hero-slide]', hero), dots = $$('[data-hero-dot]', hero);
      if (hero._timer) clearInterval(hero._timer);
      if (slides.length < 2) return;
      let i = 0;
      const speed = (parseInt(hero.dataset.speed, 10) || 6) * 1000;
      hero.style.setProperty('--hero-speed', speed / 1000 + 's');
      const go = (n) => {
        slides[i].classList.remove('is-active'); slides[i].setAttribute('aria-hidden', 'true'); dots[i] && dots[i].classList.remove('is-active');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active'); slides[i].removeAttribute('aria-hidden'); dots[i] && dots[i].classList.add('is-active');
      };
      hero._go = go;
      const play = () => { if (hero.dataset.autoplay === 'true' && !reduceMotion) { clearInterval(hero._timer); hero._timer = setInterval(() => go(i + 1), speed); } };
      const pause = () => { clearInterval(hero._timer); };
      dots.forEach((d) => d.addEventListener('click', () => { go(parseInt(d.dataset.heroDot, 10)); play(); }));
      hero.addEventListener('mouseenter', () => { pause(); hero.classList.add('is-paused'); });
      hero.addEventListener('mouseleave', () => { play(); hero.classList.remove('is-paused'); });
      hero.addEventListener('focusin', pause);
      document.addEventListener('visibilitychange', () => (document.hidden ? pause() : play()));
      play();
    });
    initHeroZoom(root);
  }

  function initHeroZoom(root = document) {
    if (reduceMotion) return;
    $$('[data-hero-zoom]', root).forEach((hero) => {
      if (hero._zoom) return; hero._zoom = true;
      let ticking = false;
      const update = () => {
        ticking = false;
        const r = hero.getBoundingClientRect();
        const p = Math.min(1, Math.max(0, -r.top / (r.height * .85)));
        hero.style.setProperty('--hp', p.toFixed(4));
      };
      window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
      update();
    });
  }

  /* ---------- Scrollers + endless autoplay ---------- */
  const cardStep = (track) => { const c = track.firstElementChild; if (!c) return track.clientWidth; const g = parseFloat(getComputedStyle(track).columnGap) || 0; return c.getBoundingClientRect().width + g; };
  const instant = (track, fn) => { const snap = track.style.scrollSnapType; track.style.scrollSnapType = 'none'; track.style.scrollBehavior = 'auto'; fn(); track.getBoundingClientRect(); track.style.scrollSnapType = snap; track.style.scrollBehavior = ''; };
  // Moves one card forward/back and rotates the DOM so the row never runs out.
  function loopMove(track, dir) {
    if (track._busy || track.scrollWidth - track.clientWidth <= 2) return;
    track._busy = true;
    const w = cardStep(track), behavior = reduceMotion ? 'auto' : 'smooth';
    if (dir > 0) {
      const max = track.scrollWidth - track.clientWidth;
      if (track.scrollLeft >= max - 4) instant(track, () => { track.appendChild(track.firstElementChild); track.scrollLeft -= w; });
      track.scrollBy({ left: w, behavior });
      setTimeout(() => { instant(track, () => { track.appendChild(track.firstElementChild); track.scrollLeft -= w; }); track._idx = (track._idx || 0) + 1; track._busy = false; track.dispatchEvent(new Event('scroll')); }, reduceMotion ? 30 : 650);
    } else {
      instant(track, () => { track.prepend(track.lastElementChild); track.scrollLeft += w; });
      track.scrollBy({ left: -w, behavior });
      setTimeout(() => { track._idx = (track._idx || 0) - 1; track._busy = false; track.dispatchEvent(new Event('scroll')); }, reduceMotion ? 30 : 650);
    }
  }
  function autoLoop(track, host, secs) {
    if (track._auto || !(secs > 0) || reduceMotion) return; track._auto = true;
    let timer = null, paused = false, visible = false;
    const tick = () => { if (!paused && visible && !document.hidden) loopMove(track, 1); };
    const start = () => { clearInterval(timer); timer = setInterval(tick, secs * 1000); };
    const pause = () => { paused = true; }, resume = () => { paused = false; start(); };
    ['mouseenter', 'focusin', 'touchstart', 'pointerdown'].forEach((ev) => host.addEventListener(ev, pause, { passive: true }));
    host.addEventListener('mouseleave', resume);
    host.addEventListener('focusout', (e) => { if (!host.contains(e.relatedTarget)) resume(); });
    host.addEventListener('touchend', () => setTimeout(resume, 4000), { passive: true });
    if ('IntersectionObserver' in window) new IntersectionObserver((en) => { visible = en[0].isIntersecting; }, { threshold: 0.3 }).observe(track); else visible = true;
    track._restart = start;
    start();
  }
  function initScrollers(root = document) {
    $$('[data-scroller]', root).forEach((s) => {
      const track = $('[data-scroller-track]', s); if (!track || track._init) return; track._init = true;
      const prev = $('[data-scroll-prev]', s), next = $('[data-scroll-next]', s), bar = $('[data-scroll-progress]', s);
      const loop = s.dataset.loop !== 'false';
      const step = () => track.clientWidth * .8;
      const go = (dir) => { if (loop) loopMove(track, dir); else track.scrollBy({ left: dir * step(), behavior: reduceMotion ? 'auto' : 'smooth' }); track._restart && track._restart(); };
      prev && prev.addEventListener('click', () => go(-1));
      next && next.addEventListener('click', () => go(1));
      const upd = () => {
        const max = track.scrollWidth - track.clientWidth;
        const ratio = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
        if (bar) {
          bar.style.width = Math.min(100, ratio * 100) + '%'; bar.parentElement.hidden = max <= 2;
          if (loop) { const n = track.children.length || 1, vis = ratio * n, i = (((track._idx || 0) % n) + n) % n; bar.style.transform = `translateX(${Math.min(i, Math.max(0, n - vis)) / vis * 100}%)`; }
          else bar.style.transform = `translateX(${max > 0 ? (track.scrollLeft / max) * ((1 / ratio) - 1) * 100 : 0}%)`;
        }
        if (loop) { if (prev) prev.disabled = max <= 2; if (next) next.disabled = max <= 2; return; }
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max - 2;
      };
      track.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
      autoLoop(track, s, parseFloat(s.dataset.autoplay) || 0);
    });
    // Product rows that become swipe carousels on mobile: autoplay + endless loop too.
    $$('.rail-mobile', root).forEach((r) => autoLoop(r, r, parseFloat(r.dataset.autoplay) || 4));
  }

  /* ---------- Editorial list hover ---------- */
  function initTlist(root = document) {
    $$('[data-tlist]', root).forEach((tl) => {
      const items = $$('[data-tlist-item]', tl), imgs = $$('[data-tlist-img]', tl);
      const set = (n) => { items.forEach((x, k) => x.classList.toggle('is-active', k === n)); imgs.forEach((x, k) => x.classList.toggle('is-active', k === n)); };
      items.forEach((it, k) => { it.addEventListener('mouseenter', () => set(k)); it.addEventListener('focus', () => set(k)); });
    });
  }

  /* ---------- Shop the look ---------- */
  function initLooks(root = document) {
    $$('[data-look]', root).forEach((look) => {
      if (look._init) return; look._init = true;
      const pop = $('[data-look-pop]', look), stage = $('[data-look-stage]', look);
      const items = $$('[data-look-item]', look);
      const total = () => {
        const el = $('[data-look-total]', look); if (!el) return;
        let sum = 0; items.forEach((it) => { const b = $('[data-quick-add]', it); if (b && !b.disabled) sum += parseInt(it.dataset.price, 10) || 0; });
        el.textContent = fmt(sum);
      };
      const activate = (n, spot) => {
        $$('[data-hotspot]', look).forEach((h) => h.classList.toggle('is-active', h.dataset.hotspot === n));
        items.forEach((it) => it.classList.toggle('is-active', it.dataset.lookItem === n));
        const item = $(`[data-look-item="${n}"]`, look); if (!item) return;
        if (isDesktop() && pop && spot) {
          const img = $('.look-item__media img', item);
          const title = $('.look-item__title', item), price = $('[data-look-price]', item), add = $('[data-quick-add]', item);
          pop.innerHTML = `<div class="look__pop-media">${img ? `<img src="${img.currentSrc || img.src}" alt="">` : ''}</div>
            <div class="look__pop-body"><span class="look__pop-title">${title ? title.textContent : ''}</span><span class="look__pop-price">${price ? price.textContent : ''}</span>
            <div class="look__pop-actions">${add ? `<button type="button" data-pop-add>${T.strings.addToBox}</button>` : `<span class="muted">${T.strings.soldOut}</span>`}<a href="${title ? title.getAttribute('href') : '#'}">View</a></div></div>`;
          pop.hidden = false;
          const sr = stage.getBoundingClientRect(), hr = spot.getBoundingClientRect();
          const x = hr.left - sr.left + hr.width / 2, y = hr.top - sr.top + hr.height / 2;
          const w = pop.offsetWidth, h = pop.offsetHeight;
          let left = x + 30; if (left + w > sr.width - 12) left = x - 30 - w;
          let top = Math.min(Math.max(12, y - h / 2), sr.height - h - 12);
          pop.style.left = Math.max(12, left) + 'px'; pop.style.top = top + 'px';
          const pa = $('[data-pop-add]', pop); if (pa) pa.addEventListener('click', () => add.click());
        } else {
          window.scrollTo({ top: item.getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h'), 10) || 0) - 24, behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      };
      look.addEventListener('click', (e) => {
        const h = e.target.closest('[data-hotspot]');
        if (h) { e.preventDefault(); activate(h.dataset.hotspot, h); return; }
        if (pop && !e.target.closest('[data-look-pop]')) pop.hidden = true;
      });
      items.forEach((it) => it.addEventListener('mouseenter', () => {
        $$('[data-hotspot]', look).forEach((h) => h.classList.toggle('is-active', h.dataset.hotspot === it.dataset.lookItem));
      }));
      look.addEventListener('change', (e) => {
        const s = e.target.closest('[data-look-variant]'); if (!s) return;
        const it = s.closest('[data-look-item]'), opt = s.selectedOptions[0];
        const b = $('[data-quick-add]', it); if (b) b.dataset.variantId = s.value;
        it.dataset.price = opt.dataset.price; $('[data-look-price]', it).textContent = fmt(parseInt(opt.dataset.price, 10));
        total();
      });
      const all = $('[data-look-add-all]', look);
      if (all) all.addEventListener('click', async () => {
        const ids = items.map((it) => $('[data-quick-add]', it)).filter((b) => b && !b.disabled).map((b) => ({ id: parseInt(b.dataset.variantId, 10), quantity: 1 }));
        if (!ids.length) return;
        busy(all, true);
        try { await Cart.add(ids); } catch (err) { toast(err.message); } finally { busy(all, false); }
      });
    });
  }

  /* ---------- Predictive search ---------- */
  function initSearch() {
    const input = $('[data-predictive-input]'), out = $('[data-predictive-results]');
    if (!input || !out || !T.routes.predictiveSearch) return;
    let ctrl;
    const run = debounce(async () => {
      const q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      if (ctrl) ctrl.abort(); ctrl = new AbortController();
      try {
        const url = `${T.routes.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product,collection,page,article&resources[limit]=8&resources[options][fields]=title,product_type,variants.title,vendor,tag&section_id=predictive-search`;
        const html = await (await fetch(url, { signal: ctrl.signal })).text();
        const node = $('[data-predictive]', parse(html));
        out.innerHTML = node ? node.innerHTML : '';
      } catch (err) { if (err.name !== 'AbortError') out.innerHTML = ''; }
    }, 260);
    input.addEventListener('input', run);
  }

  /* ---------- Collection filters (AJAX with graceful fallback) ---------- */
  function initFacets() {
    const form = $('[data-facets-form]'); if (!form) return;
    const sectionId = form.dataset.sectionId;
    const qsFromForm = () => {
      const p = new URLSearchParams();
      for (const [k, v] of new FormData(form).entries()) { if (String(v).trim() !== '') p.append(k, v); }
      return p.toString();
    };
    const apply = async (qs, scroll) => {
      const results = $('[data-facets-results]'); results && results.classList.add('is-loading');
      try {
        const html = await (await fetch(`${location.pathname}?section_id=${sectionId}${qs ? '&' + qs : ''}`)).text();
        const doc = parse(html);
        ['[data-facets-body]', '[data-facets-results]', '[data-facets-foot]'].forEach((sel) => {
          const n = $(sel, doc), c = $(sel); if (n && c) c.innerHTML = n.innerHTML;
        });
        history.replaceState({}, '', `${location.pathname}${qs ? '?' + qs : ''}`);
        initReveal($('[data-facets-results]'));
        if (scroll) { const top = $('[data-collection]').getBoundingClientRect().top + window.scrollY - 80; window.scrollTo({ top, behavior: reduceMotion ? 'auto' : 'smooth' }); }
      } catch (e) { location.href = `${location.pathname}?${qs}`; }
      finally { const r = $('[data-facets-results]'); r && r.classList.remove('is-loading'); }
    };
    const onChange = debounce(() => apply(qsFromForm(), false), 380);
    document.addEventListener('change', (e) => { if (e.target.form === form) onChange(); });
    form.addEventListener('submit', (e) => { e.preventDefault(); apply(qsFromForm(), false); });
    document.addEventListener('click', (e) => {
      const a = e.target.closest('[data-facet-link]'); if (!a || !$('[data-collection]')) return;
      e.preventDefault();
      const u = new URL(a.href, location.origin);
      apply(u.searchParams.toString(), !!a.closest('.pagination'));
    });
  }

  /* ---------- Product recommendations ---------- */
  function initRecs(root = document) {
    $$('[data-recommendations]', root).forEach((el) => {
      if (el._init || !el.dataset.url) return; el._init = true;
      const load = async () => {
        try {
          const html = await (await fetch(el.dataset.url)).text();
          const n = $('[data-recommendations]', parse(html));
          if (n && n.innerHTML.trim()) { el.innerHTML = n.innerHTML; initReveal(el); initScrollers(el); }
          else { const s = el.closest('.shopify-section'); s ? (s.hidden = true) : (el.hidden = true); }
        } catch (e) { /* silent */ }
      };
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(([en]) => { if (en.isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '400px' });
        io.observe(el);
      } else load();
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal(root = document) {
    // Every homepage/page section animates in: tag top-level blocks that have no reveal of their own.
    $$('section.section > .container', root).forEach((c) => {
      const kids = c.matches('.split, .quote, .intro, .cta-band, .why') ? [c] : [...c.children];
      kids.forEach((k, i) => { if (!k.classList.contains('reveal') && !k.querySelector('.reveal') && !k.closest('.reveal') && !k.closest('.hero')) { k.classList.add('reveal'); k.style.setProperty('--d', Math.min(i, 4) * .08 + 's'); } });
    });
    const els = $$('.reveal:not(.is-in)', root);
    document.documentElement.classList.add('reveal-on');
    if (reduceMotion || !('IntersectionObserver' in window) || document.documentElement.classList.contains('no-motion')) { els.forEach((e) => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver((ents) => ents.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    els.forEach((e) => io.observe(e));
  }

  /* ---------- Init ---------- */
  function initAll(root = document) {
    [initRotate, initHero, initScrollers, initTlist, initLooks, initVariantPicker, initGallery, initRecs, initReveal].forEach((fn) => { try { fn(root); } catch (e) { console.error(e); } });
  }
  const boot = () => { [initHeader, initSearch, initFacets, initSticky].forEach((fn) => { try { fn(); } catch (e) { console.error(e); } }); initAll(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  // Theme editor support
  document.addEventListener('shopify:section:load', (e) => { initAll(e.target); if (e.target.querySelector('[data-header]')) initHeader(); });
  document.addEventListener('shopify:block:select', (e) => {
    const hero = e.target.closest('[data-hero]');
    if (hero && hero._go) { clearInterval(hero._timer); hero._go($$('[data-hero-slide]', hero).indexOf(e.target)); }
    $$('.reveal', e.target.closest('.shopify-section') || document).forEach((x) => x.classList.add('is-in'));
  });
  document.addEventListener('shopify:section:select', (e) => $$('.reveal', e.target).forEach((x) => x.classList.add('is-in')));
})();
